/**
 * Capture payment request DTO
 */
export class CapturePaymentRequestDto {
	/**
	 * The ID of the payment to capture.
	 */
	paymentId!: number;
}
